import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateVerificationStageStatus } from "../requests/update-status.ts";
import { verifyKeys } from "../queries/keys.ts";
import type { UpdateVerificationStatusRequest } from "../../types.ts";

// Mutation hook for updating verification stage status
export const useUpdateStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateVerificationStatusRequest) => {
      const response = await updateVerificationStageStatus(data);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [...verifyKeys.all],
      });
    },
  });
};
